import { base } from './base'

const zhCN = base
export default zhCN
